module.exports = __webpack_public_path__ + "assets/img/Structure_item9.733553ca.png";